var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6 5.09999H2.97495V4.67499L12.325 3.92699V4.67499H13.6V3.39999C13.6 2.46499 12.8426 1.80879 11.9178 1.94054L3.38295 3.15944C2.4573 3.29204 1.69995 4.16499 1.69995 5.09999V13.6C1.69995 14.0509 1.87906 14.4833 2.19787 14.8021C2.51668 15.1209 2.94908 15.3 3.39995 15.3H13.6C14.0508 15.3 14.4832 15.1209 14.802 14.8021C15.1208 14.4833 15.3 14.0509 15.3 13.6V6.79999C15.3 6.34912 15.1208 5.91672 14.802 5.59791C14.4832 5.27909 14.0508 5.09999 13.6 5.09999ZM12.325 11.0551C12.1575 11.055 11.9916 11.022 11.8369 10.9578C11.6822 10.8937 11.5416 10.7997 11.4232 10.6812C11.3048 10.5628 11.2109 10.4221 11.1469 10.2674C11.0828 10.1126 11.0499 9.94673 11.05 9.77924C11.05 9.61175 11.0831 9.44591 11.1472 9.29119C11.2113 9.13647 11.3053 8.9959 11.4238 8.8775C11.5423 8.75911 11.6829 8.66521 11.8377 8.60116C11.9924 8.53712 12.1583 8.50418 12.3258 8.50424C12.6641 8.50435 12.9884 8.63883 13.2275 8.8781C13.4666 9.11737 13.6009 9.44182 13.6008 9.78009C13.6007 10.1184 13.4662 10.4427 13.2269 10.6818C12.9877 10.9209 12.6632 11.0552 12.325 11.0551Z",
    fill: "#F39C12"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.43d396c2cb099ef185b733fb5cb6cde8.svg";
export { ForwardRef as ReactComponent };